import React from "react";
import { ArticleListProps } from "./types";
import { useLazyLoad } from "../../../helpers/hooks";
const Comp = React.lazy(() => import("./ArticleList"));

export default (props: ArticleListProps) => useLazyLoad(<Comp {...props} />);
